export default ({ store }) => {
  store.dispatch('gdpr/getFingerprint')
}
